module.exports = __webpack_public_path__ + "static/media/closeHistogramChart.5dc47029.svg";